export const iconButtonVariants = {
  iconButton: 'iconButton',
  inCircle: 'inCircleMd',
}
